"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.preview.title': 'Podgląd Poradnika',
    'tutorial.preview.introduction': 'Wprowadzenie',
    'tutorial.preview.learningSteps': 'Kroki Nauki',
    'tutorial.preview.tutorialSections': 'Sekcje Poradnika',
    'tutorial.preview.knowledgeEntries': 'wpisów wiedzy',
    'tutorial.preview.sectionPrompt': 'Prompt Sekcji',
    'tutorial.preview.knowledgeBase': 'Baza Wiedzy',
    'tutorial.preview.stepSections': 'Sekcje Kroku',
    'tutorial.preview.notFound': 'Poradnik Nie Znaleziony',
    'tutorial.preview.notFoundMessage': 'Żądany poradnik nie został znaleziony lub nie masz uprawnień do jego przeglądania.',
};
